import React, { useEffect } from 'react';
import styles from './procedimentos_deialeticia1995.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const procedimentos = [
    { titulo: 'Brow lamination', imagem: require('./src/1.png') },
    { titulo: 'Designer simples de sobrancelhas', imagem: require('./src/2.png') },
    { titulo: 'Extensao de cílios - Volume Brasileiro', imagem: require('./src/3.png') },
    { titulo: 'Extensao de cílios - Volumão Brasileiro', imagem: require('./src/4.png') },
    { titulo: 'Micropgmentação labial', imagem: require('./src/5.png') },
    { titulo: 'Maquiagem', imagem: require('./src/6.png') },
    { titulo: 'Sobrancelha fio a fio', imagem: require('./src/7.png') },
];

const Procedimentos_deialeticia1995: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.procedimentos_deialeticia1995}>
            <div className={styles.header}>
                <Link to="/deialeticia1995" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h2>Procedimentos</h2>
            </div>
            <div className={styles.grid}>
                {procedimentos.map((item, index) => (
                    <div className={styles.card} key={index}>
                        <img src={item.imagem} alt={item.titulo} />
                        <h3>{item.titulo}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Procedimentos_deialeticia1995;
